<div class="input-group">
  <app-material-date-range
    class="me-2"
    id="selectedDateRangeGregorian"
    [(dateRange)]="dateRange"
    (dateRangeChange)="selectDateRange($event)"
    >
  </app-material-date-range>
    </div>
